var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirm-change-before-route"},[_vm._t("default"),_c('confirm-dialog',{ref:"confirm-before-route-leave"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }